module.exports = __webpack_public_path__ + "media/95.8d33bf84.wav";